import { Box, Button, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";
import StyledButton from "../all-products/components/custom/StyledButton";
import useGetDevice from "../hooks/useGetDevice";
import "./orders.css";
import { DataGrid } from "@mui/x-data-grid";
import { useState, useEffect, useCallback, useContext, useMemo, useRef } from "react";
import {
  getCreditOrderDetails,
  getCreditPaymentStatus,
  getSettlementDetails,
  settlePayment,
} from "../../../../config/Services";
import { customEventTrigger } from "../../../../analytics";
import { UserContext } from "App";

import cashIcon from "../../../../assets/images/coin-icon.png";
import cardIcon from "../../../../assets/images/mastercard-icon.png";
import upiIcon from "../../../../assets/images/upi-icon.png";
import offlineImg from "../../../../assets/images/offline-icon.png";
import splitImg from "../../../../assets/images/split-icon.png";

import { setAmtFocus } from "../../../ecommerce/product/all-products/redux/Actions/paginationActions";
import { getsessionPin } from "../../../ecommerce/product/all-products/redux/Reducers/sessionReducer";
import { useSelector } from "react-redux";
import usePrint from "../hooks/usePrint";
import CreditOrdersPaymentModal from "../all-products/components/twoWaykeyboardPaymentPage/components/paymentModal/creditOrdersPaymentModal";
import { useSnackbar } from "../hooks/SnackbarProvider";

import OrderDetailsNew from "./newOrderDetails";
import { useNavigate } from "react-router-dom";
import { convertToLocalDateTime } from "../all-products/Middleware/commonUtils";

export const CreditOrderDetailsPage = ({ orderid, onRefresh }) => {
  const isMobile = useGetDevice();

  const [loading, setLoading] = useState(false);

  const [newLoader, setNewLoader] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);
  const [payLoader, setPayLoader] = useState(false);
  const [partialStatus, setPartailStatus] = useState(false);
  const [paymentMode, setPaymentMode] = useState("");
  const storeMode = localStorage.getItem("storeMode");
  const [cashChange, setCashChange] = useState(false);
  const cashierPin = useSelector(getsessionPin);
  const [paymentCancel, setPaymentCancel] = useState(false);
  const [selectedButton, setSelectedButton] = useState("allorders");
  const { openDrawer } = usePrint();

  const [paymentFailed, setPaymentFailed] = useState(false);
  const machineId = localStorage.getItem("machineId");
  const licenseName = localStorage.getItem("licenseName");
  const [newId, setNewId] = useState("");
  const failedImgWarning = "https://icon-library.net/images/failed-icon/failed-icon-8.jpg";
  const cancelGif =
    "https://cdn0.iconfinder.com/data/icons/banking-156/60/cancel__delete__payment__card__credit-512.png";

  const { total, setTotal, paymentMethod, setPaymentMethod } = useContext(UserContext);

  const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails") || "{}");
  const firstName = retailUserDetails?.firstName;
  const uidx = retailUserDetails?.uidx;

  const [pageState, setPageState] = useState({
    loader: false,
    dataRows: [],
    total: 0,
    page: 1,
    pageSize: 8,
  });

  const showSnackbar = useSnackbar();

  const [customerName, setCustomerName] = useState("");
  const [customerContact, setCustomerContact] = useState("");
  const [outstandingAmount, setOutstandingAmount] = useState("");
  const [outStandingOrders, setOutStandingOrders] = useState("");
  const [customerIdd, setCustomerIdd] = useState("");
  const [invoiceAging, setInvoiceAging] = useState("");
  const [lastPayment, setLastPayment] = useState("");
  const [openPayModal, setOpenPayModal] = useState(false);
  const [splitActive, setSplitActive] = useState(false);
  const [amtHeading, setAmtHeading] = useState("");
  const [amountDue, setAmountDue] = useState("0");
  const [adjustCheck, setAdjustCheck] = useState(false);
  const [amtToBePaid, setAmtToBePaid] = useState("");
  const [singleOrderoffline, setSingleOrderOffline] = useState(false);
  const [enterAmount, setEnterAmount] = useState("");
  const [amountPaid, setAmountPaid] = useState("0");
  const [functionCalled, setFunctionCalled] = useState(false);
  const [cardFunctionCalled, setCardFunctionCalled] = useState(false);
  const [splitFunctionCalled, setSplitFunctionCalled] = useState(false);
  const [paymentLoader, setpaymentLoader] = useState(false);
  const [paymentLoadingModal, setPaymentLoadingModal] = useState(false);
  const [manual, setManaul] = useState(false);
  const [transCode, setTransCode] = useState("");
  const [approveloader, setApproveLoader] = useState(false);
  const [cancelLoader, setCancelLoader] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const { startPrint, isPrinting, connectPrinter, isError } = usePrint();
  const [orderId, setOrderId] = useState("");
  const [rowOrderId, setRowOrderId] = useState("");
  const [newTransId, setNewTransId] = useState(false);

  const sessionId = localStorage.getItem("sessionId");
  const licenseId = localStorage.getItem("licenseId");
  const orgId = localStorage.getItem("orgId");
  const locId = localStorage.getItem("locId");
  const [accountNoteId, setAccountNoteId] = useState("");
  const [billTabValue, setBillTabValue] = useState("0");

  const handleManual = () => {
    setManaul(true);
  };
  const navigate = useNavigate();

  const handleOffline = () => {
    setSingleOrderOffline(true);
  };

  useMemo(() => {
    if (paymentMethod === "UPI" || paymentMethod === "CARD") {
      setPaymentMode("ONLINE");
    } else {
      setPaymentMode("OFFLINE");
    }
  }, [paymentMethod]);

  const fetchData = async (response, type) => {
    if (type == "allorders") {
      const customerDetails = response?.data?.data?.accountNote || [];
      setCustomerName(customerDetails?.customerName || "NA");
      setCustomerContact(customerDetails?.mobileNumber || "NA");
      setOutstandingAmount(customerDetails?.outStandingAmount ?? "NA");
      setOutStandingOrders(customerDetails?.outStandingOrders ?? "NA");
      setInvoiceAging(customerDetails?.invoiceAging || "NA");
      setLastPayment(
        customerDetails?.lastPaymentDate
          ? convertToLocalDateTime(customerDetails?.lastPaymentDate)
          : "NA"
      );
      setTotal(customerDetails?.outStandingAmount);
      setCustomerIdd(customerDetails?.customerId);
      setAccountNoteId(customerDetails?.accountNoteId);
      setAmtToBePaid(Math.abs(customerDetails?.outStandingAmount).toFixed(2));
      if (customerDetails?.outStandingAmount > 0) {
        setAmtHeading("Payable Amount");
      } else {
        setAmtHeading("Recievable Amount");
      }

      const dataArr = response?.data?.data?.accountNote?.accountLogs || [];
      const data = dataArr?.map((row, index) => ({
        id: index,
        date: row?.createdDate?.split("T")[0] || "NA",
        orderId: row?.orderId || "NA",
        items: row?.items || "NA",
        cashier: row?.cashier || "NA",
        invoiceAging: row?.invoiceAging || "NA",
        paymentStatus: row?.status || "NA",
        amount: row?.orderAmount || "NA",
        paymentDate: row?.paymentDate ? convertToLocalDateTime(row?.paymentDate) : "NA",
        paymentProcessedBy: row?.updatedByName || "NA",
      }));
      setLoading(false);
      setPageState((old) => ({
        ...old,
        loader: false,
        total: response?.data?.data?.totalResults || 0,
        dataRows: data || [],
      }));
    } else {
      const dataArr = response?.data?.data?.settlements || [];
      const data = dataArr?.map((row, index) => ({
        id: index,
        settlementid: row?.settlementId || "NA",
        amount: row?.amount || "NA",
        settlementdate: row?.modifiedDate ? convertToLocalDateTime(row?.modifiedDate) : "NA",
        paymentmethod: row?.paymentMethod || "NA",
        paymentmode: row?.paymentMode || "NA",
      }));
      setLoading(false);
      setPageState((old) => ({
        ...old,
        loader: false,
        total: response?.data?.data?.totalResults || 0,
        dataRows: data || [],
      }));
    }
  };

  const callPaymentStatus = (transId, currentRetry, settlement, setID) => {
    const payload = {
      customerId: customerIdd,
      amount: enterAmount,
      locationId: locId,
      orgId: orgId,
      sessionId: sessionId,
      licenseId: licenseId,
      licenseName: licenseName,
      machineCode: machineId,
      accountNoteId: accountNoteId,
      paymentMethod: paymentMethod,
      // paymentMode: machineId ? "ONLINE" : "OFFLINE",
      paymentMode: storeMode,
      updatedByName: firstName || null,
      settlementStatus: "COMPLETED",
      createdBy: uidx,
    };

    let maxRetries = 95;
    let retry = currentRetry || 0;
    // setEnterAmount(enterAmount);

    getCreditPaymentStatus(transId, settlement, setID)
      .then((res) => {
        if (
          res?.data?.data?.paymentResponseModel?.paymentStatus === "PAYMENT_INITIATED" &&
          retry < maxRetries
        ) {
          retry++;
          showSnackbar(res?.data?.data?.paymentResponseModel?.paymentStatus, "success");
          setPaymentLoadingModal(true);
          setpaymentLoader(true);
          setPaymentSuccess(false);
          setTimeout(() => callPaymentStatus(transId, retry, settlement, setID), 2000 + retry);
          if (retry === maxRetries) {
            setPaymentFailed(true);
            setCancelTarsn(true);
          }
        } else if (res?.data?.data?.paymentResponseModel?.paymentStatus === "COMPLETED") {
          showSnackbar(res?.data?.data?.paymentResponseModel?.paymentStatus, "success");
          settlePayment(payload);
          closePaymentModal();
          resetValues();
          fetchDetails("allorders");
          onRefresh();
          navigate("/credit-order-completed", {
            state: {
              amount: enterAmount,
              paymentMethod: paymentMethod,
              settlementId: setID,
              customerName,
              customerMobile: customerContact,
            },
          });
        } else if (
          res?.data?.data?.paymentResponseModel?.paymentStatus === "PAYMENT_CANCELLED" ||
          res?.data?.data?.paymentResponseModel?.paymentStatus === "CANCELLED"
        ) {
          retry === maxRetries;
          setPaymentLoadingModal(false);
          setCancelLoader(false);
          setpaymentLoader(false);
          showSnackbar(res?.data?.data?.paymentResponseModel?.paymentStatus, "error");

          // retry===1000
        }
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
      });
  };

  const settlePaymentFun = () => {
    // paymentMode: machineId ? "ONLINE" : "OFFLINE",
    setModalLoader(true);
    if (enterAmount === 0 || enterAmount === "" || enterAmount < 1) {
      showSnackbar("You need to pay atleast 1 Rupee to process this order", "error");
      setModalLoader(false);
      return;
    }
    const payload = {
      customerId: customerIdd,
      amount: enterAmount,
      locationId: locId,
      orgId: orgId,
      sessionId: sessionId,
      licenseId: licenseId,
      licenseName: licenseName,
      machineCode: machineId,
      accountNoteId: accountNoteId,
      paymentMethod: paymentMethod,
      // paymentMode: "OFFLINE",
      paymentMode: storeMode,
      updatedByName: firstName || null,
      settlementStatus: "PENDING",
      createdBy: uidx,
    };

    settlePayment(payload)
      .then((res) => {
        if (res?.data?.data?.es == 0) {
          if (machineId && paymentMethod !== "CASH") {
            callPaymentStatus(
              res?.data?.data?.transactionCode,
              0,
              true,
              res?.data?.data?.settlementId
            );
            return;
          }
          if (paymentMethod === "CASH") {
            openDrawer();
          }
          closePaymentModal();
          resetValues();
          fetchDetails("allorders");
          onRefresh();
          navigate("/credit-order-completed", {
            state: {
              amount: enterAmount,
              paymentMethod: paymentMethod,
              settlementId: res?.data?.data?.settlementId,
              customerName,
              customerMobile: customerContact,
            },
          });
          setModalLoader(false);
        } else {
          setModalLoader(false);
          showSnackbar("Sorry something went wrong ,please try again", "error");
        }
      })
      .catch((err) => {
        showSnackbar(
          err?.message ||
            err?.response?.data?.message ||
            "Sorry something went wrong,please try again",
          "error"
        );
        setModalLoader(false);
      });
  };

  const settLementListingFun = () => {
    setPageState((old) => ({
      ...old,
      page: 1,
    }));
    setSelectedButton("allsettlements");
    fetchDetails("allsettlements");
  };

  const creditOrdersLisingFun = () => {
    setPageState((old) => ({
      ...old,
      page: 1,
    }));
    setSelectedButton("allorders");
    fetchDetails("allorders");
  };

  const handleTansactionCancel = () => {
    setCancelLoader(true);
    let payload = {
      orderId: newId,
      transactionCode: newTransId,
    };
    orderCancelRequest(payload).then((res) => {
      if (res?.data?.data?.statusModel?.orderStatus === "PAYMENT_CANCELLED") {
        setPaymentLoadingModal(false);
        setCancelLoader(false);
        setPartailStatus(true);
        setEnterAmount("");
      } else if (res?.data?.data?.statusModel?.paymentStatus === "PAYMENT_PENDING") {
        setPaymentLoadingModal(false);
        setCancelLoader(false);
        setPartailStatus(true);
        setEnterAmount("");
        setOrderStatus(true);
        callPaymentStatus(newTransId);
      }
    });
  };

  const resetValues = () => {
    setPaymentLoadingModal(false);
    setSingleOrderOffline(false);
    setSplitActive(false);
    setEnterAmount("");
    setPayLoader(false);
    setCashChange(false);
    setPartailStatus(false);
    setAdjustCheck(false);
    setAmountPaid("");
    setTotal("");
  };

  const fetchDetails = useCallback(
    async (type) => {
      setLoading(true);
      try {
        const payload = {
          accountNoteId: orderid,
          page: pageState.page - 1,
          pageSize: 8,
        };
        if (type == "allorders") {
          const response = await getCreditOrderDetails(payload);
          await fetchData(response, "allorders");
        } else if (type == "allsettlements") {
          const response = await getSettlementDetails(payload);

          await fetchData(response, "allsettlements");
        }
      } catch (error) {
        showSnackbar("Failed to fetch data. Please try again.");
      } finally {
        setLoading(false);
      }
    },
    [orderid, pageState.page]
  );

  useEffect(() => {
    fetchDetails(selectedButton);
  }, [fetchDetails, pageState.page]);

  //handle orders manually

  const clrAmountFun = () => setEnterAmount("");

  const handleOpenPaymentModal = () => {
    customEventTrigger("pos_payment_page");
    setOpenPayModal(true);
  };

  const closePaymentModal = useCallback(() => {
    setOpenPayModal(false);
  }, [splitActive, partialStatus]);

  const handleSplitPayment = () => {
    setPaymentMethod("CASH");
    setSplitActive(true);
  };

  const handlesplitInputChange = (e) => {
    const valueInput = e.target.value;
    setEnterAmount(valueInput);
  };

  const enterAmountRef = useRef(null);

  const handleCellClick =
    selectedButton === "allorders"
      ? (params, event) => {
          setRowOrderId(params?.row?.orderId);
          setBillTabValue("1");
        }
      : undefined;

  const columns =
    selectedButton === "allorders"
      ? [
          { field: "date", headerName: "Date", width: 150 },
          { field: "orderId", headerName: "Order Id", width: 150 },
          { field: "items", headerName: "Items", width: 100 },
          { field: "cashier", headerName: "Cashier", width: 150 },
          { field: "invoiceAging", headerName: "Invoice Aging", width: 130 },
          { field: "paymentStatus", headerName: "Payment Status", width: 150 },
          { field: "amount", headerName: "Amount", width: 100 },
          { field: "paymentDate", headerName: "Payment Date", width: 200 },
          { field: "paymentProcessedBy", headerName: " Payment Processed by", width: 180 },
        ]
      : [
          { field: "settlementid", headerName: "Settlement Id", width: 260 },
          { field: "amount", headerName: "Amount Paid", width: 260 },
          { field: "settlementdate", headerName: "Settlement Date", width: 260 },
          { field: "paymentmethod", headerName: "Payment Method", width: 260 },
          { field: "paymentmode", headerName: "Payment Mode", width: 260 },
        ];
  return (
    <Box sx={{ width: "100%" }} className="receipt-wrapper-box">
      {billTabValue == "1" && (
        <StyledButton
          size="medium"
          style={{ margin: "5px" }}
          onClick={() => {
            setBillTabValue("0");
          }}
        >
          Customer Overview
        </StyledButton>
      )}
      {loading ? (
        <Box className="loader-order-details-page">
          <CircularProgress />
        </Box>
      ) : (
        <>
          {billTabValue === "0" && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Box sx={{ display: "flex", flexDirection: "column", padding: "20px" }}>
                  <Typography variant="p" fontSize="16px" fontWeight="bold">
                    {customerName || "NA"}
                  </Typography>
                  <Typography variant="p" fontSize="16px">
                    {customerContact || "NA"}
                  </Typography>
                  <Box sx={{ display: "flex", gap: "15px", marginTop: "10px" }}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                      <Typography variant="p" fontSize="13px">
                        Outstanding Orders
                      </Typography>
                      <Typography variant="p" fontSize="15px" fontWeight="bold">
                        {outStandingOrders ?? "NA"}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                      <Typography variant="p" fontSize="13px">
                        Invoice aging
                      </Typography>
                      <Typography variant="p" fontSize="15px" fontWeight="bold">
                        {invoiceAging || "NA"}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                      <Typography variant="p" fontSize="13px">
                        Last payment
                      </Typography>
                      <Typography variant="p" fontSize="15px" fontWeight="bold">
                        {lastPayment || "NA"}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                <Box sx={{ display: "flex", flexDirection: "column", padding: "20px" }}>
                  <Typography variant="p" fontSize="16px" fontWeight="bold">
                    Outstanding
                  </Typography>
                  <Typography variant="p" fontSize="16px">
                    {outstandingAmount ?? "NA"}
                  </Typography>
                  <StyledButton
                    disabled={outstandingAmount == 0}
                    color="rgb(80, 200, 120)"
                    id="confirm-wrapper-btn"
                    className="sub-total-wrapper-container-credit-order-details"
                    onClick={handleOpenPaymentModal}
                  >
                    Pay
                  </StyledButton>
                </Box>
              </Box>

              <Divider />

              <Box sx={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                <StyledButton
                  onClick={creditOrdersLisingFun}
                  color={selectedButton === "allsettlements" ? "#E0DFDF" : "#007AFF"}
                  style={{
                    color: selectedButton === "allsettlements" ? "#000000DE" : "#FFFFFF",
                  }}
                  size="small"
                >
                  All orders
                </StyledButton>
                <StyledButton
                  onClick={settLementListingFun}
                  color={selectedButton === "allorders" ? "#E0DFDF" : "#007AFF"}
                  style={{
                    color: selectedButton === "allorders" ? "#000000DE" : "#FFFFFF",
                  }}
                  size="small"
                >
                  All settlements
                </StyledButton>
              </Box>

              <Box>
                <DataGrid
                  columns={columns}
                  rows={pageState.dataRows}
                  page={pageState.page - 1}
                  loading={pageState.loader}
                  pageSize={pageState.pageSize}
                  rowsPerPageOptions={[8]}
                  pagination
                  rowCount={parseInt(pageState.total)}
                  paginationMode="server"
                  onPageChange={(newPage) => {
                    setPageState((old) => ({ ...old, page: newPage + 1 }));
                  }}
                  autoHeight={true}
                  onCellClick={handleCellClick}
                  sx={{
                    "& .super-app.Paid": {
                      color: "#69E86D",
                      fontSize: "1em",
                      fontWeight: "600",
                      margin: "0px auto 0px auto",
                      padding: "5px",
                    },
                    "& .super-app.Create": {
                      color: "blue",
                      fontSize: "1em",
                      fontWeight: "600",
                      margin: "0px auto 0px auto",
                      padding: "5px",
                    },
                    "& .super-app.Adjust": {
                      color: "darkred",
                      fontSize: "1em",
                      fontWeight: "600",
                      margin: "0px auto 0px auto",
                      padding: "5px",
                    },
                    "& .super-app.Pending": {
                      color: "orange",
                      fontSize: "1em",
                      fontWeight: "600",
                      margin: "0px auto 0px auto",
                      padding: "5px",
                    },
                    "& .super-app.Cancel": {
                      color: "red",
                      fontSize: "1em",
                      fontWeight: "600",
                      margin: "0px auto 0px auto",
                      padding: "5px",
                    },
                    "& .super-app.Payment_Cancel": {
                      color: "red",
                      fontSize: ".75em",
                      fontWeight: "900",
                      margin: "0px auto 0px auto",
                      padding: "5px",
                    },
                    "& .super-app.Partial_Paid": {
                      color: "orange",
                      fontSize: "1em",
                      fontWeight: "900",
                      margin: "0px auto 0px auto",
                      padding: "5px",
                    },
                  }}
                />
              </Box>
            </Box>
          )}
          {/* payment modal */}

          <CreditOrdersPaymentModal
            openPayModal={openPayModal}
            closePaymentModal={closePaymentModal}
            handleOpenPaymentModal={handleOpenPaymentModal}
            newLoader={newLoader}
            modalLoader={modalLoader}
            payLoader={payLoader}
            partialStatus={partialStatus}
            paymentMethod={paymentMethod}
            splitActive={splitActive}
            setSplitActive={setSplitActive}
            amtHeading={amtHeading}
            amountDue={amountDue}
            adjustCheck={adjustCheck}
            amtToBePaid={amtToBePaid}
            setPaymentMethod={setPaymentMethod}
            cashIcon={cashIcon}
            upiIcon={upiIcon}
            cardIcon={cardIcon}
            storeMode={storeMode}
            handleOffline={handleOffline}
            singleOrderoffline={singleOrderoffline}
            offlineImg={offlineImg}
            splitImg={splitImg}
            handleSplitPayment={handleSplitPayment}
            settlePaymentFun={settlePaymentFun}
            clrAmountFun={clrAmountFun}
            enterAmount={enterAmount}
            setEnterAmount={setEnterAmount}
            enterAmountRef={enterAmountRef}
            setAmtFocus={setAmtFocus}
            cashChange={cashChange}
            handlesplitInputChange={handlesplitInputChange}
            amountPaid={amountPaid}
            functionCalled={functionCalled}
            setFunctionCalled={setFunctionCalled}
            cardFunctionCalled={cardFunctionCalled}
            setCardFunctionCalled={setCardFunctionCalled}
            setSplitFunctionCalled={setSplitFunctionCalled}
            splitFunctionCalled={splitFunctionCalled}
            paymentLoader={paymentLoader}
            paymentLoadingModal={paymentLoadingModal}
            manual={manual}
            transCode={transCode}
            approveloader={approveloader}
            cashierPin={cashierPin}
            paymentFailed={paymentFailed}
            newId={newId}
            failedImgWarning={failedImgWarning}
            handleTansactionCancel={handleTansactionCancel}
            cancelLoader={cancelLoader}
            paymentSuccess={paymentSuccess}
            isError={isError}
            isPrinting={isPrinting}
            orderId={orderId}
            resetValues={resetValues}
            paymentCancel={paymentCancel}
            cancelGif={cancelGif}
            handleManual={handleManual}
            newTransId={newTransId}
            setPaymentSuccess={setPaymentSuccess}
            setpaymentLoader={setpaymentLoader}
            outStandingAmount={outstandingAmount}
          />
        </>
      )}

      {billTabValue == "1" && (
        <div class="center bill-preview">
          <OrderDetailsNew orderId={rowOrderId} />
        </div>
      )}
    </Box>
  );
};
